<template>
  <availability>
    <div class="availability-time">
      <div class="title">Set Up Time slots for each week day</div>
      <div class="week-day">
        <div
          v-for="(week, index) in weeks"
          @click="setWeek(index)"
          :key="index"
          class="day"
          :class="{ selected: selectedWeek === index }"
        >
          <span>{{ week }}</span>
        </div>
      </div>

      <div class="times-wrap">
        <div class="time-desc">
          <div
            class="time"
            v-for="index in 19"
            :key="index"
            :class="{ 'time-standard': timeStandards[index] }"
          >
            <span>
              {{ timeStandards[index] ? timeStandards[index].text : '' }}
            </span>
          </div>
        </div>
        <div class="times">
          <div
            class="time"
            v-for="index in [
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24
            ]"
            :key="index"
            :class="{ selected: checkSelect(index) }"
            @click="selectTime(index)"
          ></div>
        </div>
      </div>
      <div class="time-box">
        <transition-group name="list" mode="out-in">
          <div
            class="item"
            v-for="(item, index) in eachWeekTime[selectedWeek]"
            :key="index + 'time'"
          >
            <span class="time">
              {{ item.startTime / 60 }}:00
              {{ item.startTime / 60 > 12 ? 'pm' : 'am' }} ~
              {{ item.endTime / 60 }}:00
              {{ item.endTime / 60 > 12 ? ' pm' : ' am' }}
            </span>
            <button @click="removeTime(index)" class="button__delete">
              <span>DELETE</span>
            </button>
          </div>
        </transition-group>
      </div>
    </div>
  </availability>
</template>

<script>
import Availability from './Availability'
import { setTime, getTimes } from '../../api/availability'
import { setTimeout } from 'timers'

export default {
  name: 'availability-time',
  components: { Availability },
  data() {
    return {
      weeks: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
      timeStandards: {
        1: {
          text: '6am'
        },
        7: {
          text: 'noon'
        },
        14: {
          text: '6pm'
        },
        23: {
          text: '24am'
        }
      },
      selectedWeek: 0,
      selectedTimes: {},
      currentTimes: [],
      tempSaveTime: {},
      eachWeekTime: {}
    }
  },
  created() {
    this.selectedTimes[this.selectedWeek] = []
    this.currentTimes = this.selectedTimes[this.selectedWeek]
  },
  mounted() {
    this.getAvailabilityTime()
  },
  methods: {
    getAvailabilityTime() {
      getTimes(this.$store.getters.userInfo.uid).then(data => {
        console.log('get avaliabilityTime:', data)
        this.eachWeekTime = typeof data.times === 'undefined' ? [] : data.times
        if (typeof data.timeBar !== 'undefined') {
          console.log('init selectedTimes:', this.selectedTimes)
          this.selectedTimes = data.timeBar
          setTimeout(() => {
            this.setWeek(0)
          }, 0)
        }
      })
    },
    removeTime(index) {
      console.log(
        'this.eachWeekTime[this.selectedWeek]:',
        this.eachWeekTime[this.selectedWeek]
      )
      const timeIndex = this.eachWeekTime[this.selectedWeek][index]
      const start = timeIndex.startTime / 60
      const end = timeIndex.endTime / 60

      // 스타트 시간과 끝시간사이에 있는 값을 다 지워준다.
      for (let i = start; i <= end; i++) {
        const deleteIndex = this.selectedTimes[this.selectedWeek].indexOf(i)
        this.$delete(this.selectedTimes[this.selectedWeek], deleteIndex)
      }

      this.$delete(this.eachWeekTime[this.selectedWeek], index)
      // this.convertTime()
    },
    checkSelect(index) {
      return this.currentTimes.indexOf(index) > -1 ? true : false
    },
    setWeek(index) {
      this.selectedWeek = index
      if (typeof this.selectedTimes[this.selectedWeek] !== 'undefined') {
        this.currentTimes = this.selectedTimes[this.selectedWeek]
      } else {
        // Object.assign(this.selectedTimes, this.selectedWeek, [])
        this.selectedTimes[this.selectedWeek] = []
        this.currentTimes = this.selectedTimes[this.selectedWeek]
      }
    },
    selectTime(index) {
      const startIndex = this.selectedTimes[this.selectedWeek].indexOf(index)
      if (startIndex >= 0) {
        this.selectedTimes[this.selectedWeek].splice(startIndex, 1)
      } else {
        this.selectedTimes[this.selectedWeek].push(index)
      }

      let result = this.selectedTimes[this.selectedWeek].sort((a, b) => {
        return a - b
      })

      console.log(result)

      this.convertTime()
    },
    // 배열로 저장된 숫자를 시간의 분으로 변환한다.
    convertTime() {
      // 데이터 이중화를 한다. 상단 상태 표시용과, 하단 상태 표시용을 별도로 저장한다.
      console.clear()
      console.log('selectedTimes:', this.selectedTimes)
      let timeBucket = []
      const eachWeekTime = {}
      new Promise(resolve => {
        const resultTime = Object.keys(this.selectedTimes).map((v, i) => {
          return this.selectedTimes[i].reduce((a, c, ii, self) => {
            timeBucket.push(c)
            const nextTime = self[ii + 1] === c + 1 // 연속적인 값이 있는지 체크 한다.
            console.log('next time:', nextTime)
            if (nextTime) {
              return c
            } else {
              const startTime = timeBucket[0] * 60
              const endIndex =
                timeBucket.length === 1 ? 0 : timeBucket.length - 1
              const endTime =
                timeBucket.length === 1
                  ? timeBucket[endIndex] * 60 + 60
                  : timeBucket[endIndex] * 60 + 60
              if (!Array.isArray(eachWeekTime[i])) eachWeekTime[i] = []
              eachWeekTime[i].push({ startTime, endTime })
              timeBucket = []
              return a
            }
          }, this.selectedTimes[i][0])
        })
        resolve(resultTime)
      }).then(r => {
        console.log(r)
        this.eachWeekTime = eachWeekTime
        setTime(
          { times: this.eachWeekTime, timeBar: this.selectedTimes },
          this.$store.getters.userInfo.uid
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.availability-time {
  width: 1080px;
  position: relative;
  left: 0;
  right: 0;
  margin: auto auto 80px auto;
  font-family: Poppins;

  .title {
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;
    margin: 40px 0 12px;
  }

  .week-day {
    width: 100%;
    height: 90px;
    display: inline-flex;
    flex-direction: row;
    justify-items: stretch;

    .day {
      height: 90px;
      text-align: center;
      flex: auto;
      display: flex;
      margin: 0 0 0 1px;
      background-color: #f5f5f5;
      font-size: 17px;
      letter-spacing: 1px;
      cursor: pointer;

      &:first-child {
        /*width: 100%;*/
        margin: 0;
      }

      span {
        flex: auto;
        align-self: center;
      }

      &.selected {
        background-color: #0fb564;
        color: #fff;
        font-weight: 600;
      }
    }
  }

  .times-wrap {
    .time-desc {
      width: 100%;
      height: 28px;
      display: flex;
      margin: 40px 0 0;
      position: relative;

      .time {
        height: 28px;
        flex: 1;
        text-align: center;
        font-weight: 300;
        font-size: 17px;
        letter-spacing: 1px;
        /*border-left: 1px solid #ccc;*/
        /*padding: 0 0 0 5px;*/
        position: relative;

        span {
          position: absolute;
        }
      }

      .time-standard {
        position: relative;

        &::before {
          display: block;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-left: 1px solid #ccc;
        }
      }
    }

    .times {
      width: 100%;
      height: 52px;
      display: inline-flex;
      flex-direction: row;
      justify-items: stretch;

      .time {
        height: 50px;
        flex: 1;
        cursor: pointer;
        user-select: none;
        position: relative;

        &::before {
          display: block;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
        }

        &:first-child {
          &::before {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-left: 1px solid #ccc;
          }
        }

        &:nth-child(2n) {
          &::before {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-right: 1px solid #ccc;
          }
        }

        &.selected {
          background-color: #10b564;
        }
      }
    }
  }

  .time-box {
    margin: 60px 0 0 0;

    .item {
      width: 1080px;
      height: 92px;
      margin: 0 0 20px 0;
      border: solid 1px #e7e7e7;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .time {
        margin: 0 0 0 20px;
        height: 32px;
        font-family: Poppins;
        font-size: 20px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      .button__delete {
        cursor: pointer;
        width: 150px;
        height: 50px;
        margin: 0 20px 0 0;
        border-radius: 2px;
        border: solid 1px #dddddd;
        background-color: #ffffff;
      }
    }
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
    opacity: 0;
    transform: translateX(30px);
  }
}
</style>
